export type Cta = {
  icon?: string;
  url?: string;
  page?: { uri?: string };
  file?: { link?: string };
  title: string;
};

export function getCtaUrl(cta: Cta): string | undefined {
  return cta.url || cta.page?.uri || cta.file?.link;
}
